import { jsx as H } from "react/jsx-runtime";
const t = ({
  size: V
}) => {
  switch (V) {
    case "sm":
      return /* @__PURE__ */ H(
        "path",
        {
          d: "M7.49834 13.8317V10.165H8.49834V11.4984H13.8317V12.4984H8.49834V13.8317H7.49834ZM2.16501 12.4984V11.4984H5.83168V12.4984H2.16501ZM4.83168 9.83171V8.49837H2.16501V7.49837H4.83168V6.16504H5.83168V9.83171H4.83168ZM7.49834 8.49837V7.49837H13.8317V8.49837H7.49834ZM10.165 5.83171V2.16504H11.165V3.49837H13.8317V4.49837H11.165V5.83171H10.165ZM2.16501 4.49837V3.49837H8.49834V4.49837H2.16501Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ H(
        "path",
        {
          d: "M11.25 20.75V15.25H12.75V17.25H20.75V18.75H12.75V20.75H11.25ZM3.25 18.75V17.25H8.75V18.75H3.25ZM7.25 14.75V12.75H3.25V11.25H7.25V9.25H8.75V14.75H7.25ZM11.25 12.75V11.25H20.75V12.75H11.25ZM15.25 8.75V3.25H16.75V5.25H20.75V6.75H16.75V8.75H15.25ZM3.25 6.75V5.25H12.75V6.75H3.25Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ H(
        "path",
        {
          d: "M9.37333 17.2933V12.71H10.6233V14.3766H17.29V15.6266H10.6233V17.2933H9.37333ZM2.70667 15.6266V14.3766H7.29V15.6266H2.70667ZM6.04 12.2933V10.6266H2.70667V9.37663H6.04V7.70996H7.29V12.2933H6.04ZM9.37333 10.6266V9.37663H17.29V10.6266H9.37333ZM12.7067 7.29329V2.70996H13.9567V4.37663H17.29V5.62663H13.9567V7.29329H12.7067ZM2.70667 5.62663V4.37663H10.6233V5.62663H2.70667Z",
          fill: "currentColor"
        }
      );
  }
}, M = ({
  size: V
}) => {
  switch (V) {
    case "sm":
      return /* @__PURE__ */ H(
        "path",
        {
          d: "M7.30317 14.122V9.9985H8.76V11.3318H14.0933V12.7887H8.76V14.122H7.30317ZM1.91 12.7887V11.3318H6.0335V12.7887H1.91ZM4.57667 10.0583V8.725H1.91V7.272H4.57667V5.93867H6.0335V10.0583H4.57667ZM7.30317 8.725V7.272H14.0933V8.725H7.30317ZM9.96984 5.9985V1.875H11.4267V3.20833H14.0933V4.66517H11.4267V5.9985H9.96984ZM1.91 4.66517V3.20833H8.70017V4.66517H1.91Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ H(
        "path",
        {
          d: "M10.9572 21.1854V15.0002H13.1425V17.0002H21.1425V19.1854H13.1425V21.1854H10.9572ZM2.86749 19.1854V17.0002H9.05274V19.1854H2.86749ZM6.86749 15.0899V13.0899H2.86749V10.9104H6.86749V8.91044H9.05274V15.0899H6.86749ZM10.9572 13.0899V10.9104H21.1425V13.0899H10.9572ZM14.9572 9.00019V2.81494H17.1425V4.81494H21.1425V7.00019H17.1425V9.00019H14.9572ZM2.86749 7.00019V4.81494H13.0527V7.00019H2.86749Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ H(
        "path",
        {
          d: "M9.12979 17.6537V12.4993H10.9508V14.166H17.6175V15.9871H10.9508V17.6537H9.12979ZM2.38834 15.9871V14.166H7.54271V15.9871H2.38834ZM5.72167 12.5741V10.9075H2.38834V9.09122H5.72167V7.42455H7.54271V12.5741H5.72167ZM9.12979 10.9075V9.09122H17.6175V10.9075H9.12979ZM12.4631 7.49935V2.34497H14.2842V4.01164H17.6175V5.83268H14.2842V7.49935H12.4631ZM2.38834 5.83268V4.01164H10.876V5.83268H2.38834Z",
          fill: "currentColor"
        }
      );
  }
}, e = ({
  size: V = "md",
  weight: r = "default"
}) => {
  switch (r) {
    case "bold":
      return /* @__PURE__ */ H(M, { size: V });
    case "book":
    case "default":
      return /* @__PURE__ */ H(t, { size: V });
  }
};
export {
  e as default
};
//# sourceMappingURL=DIconFilter.js.map
